import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { connect } from 'react-redux';

import actions from '../../store/actions';

const enhance = connect(null, {
  setSelectedMassId: actions.setSelectedMassId,
});

export const ChangeDateButton = ({ setSelectedMassId }) => {
  const setMassOffering = () => {
    setSelectedMassId(null);
  };

  return (
    <Button onClick={setMassOffering} type="link">
      Zmień termin
    </Button>
  );
};

ChangeDateButton.propTypes = {
  setSelectedMassId: PropTypes.func,
};

export default enhance(ChangeDateButton);
